export default "__VITE_PUBLIC_ASSET__b328f3f9__"